import type { BankExpenseCategorizationRule, MonthlyReportExpenseLine } from '../types';
import { applyCategorizationRuleToLine, normalizeBankTransactionPatternKey } from './bankExpenseCategorization';

export function buildAnzDebitExpenseLine(
  uniqueTxnId: string,
  amountAbs: number,
  details: string,
  reference: string,
  code: string,
  rulesByPatternKey: Map<string, BankExpenseCategorizationRule>
): { line: MonthlyReportExpenseLine; appliedRule: boolean } {
  const label = [details, reference].filter(Boolean).join(' · ') || code || 'Bank debit';
  const base: MonthlyReportExpenseLine = {
    id: uniqueTxnId,
    amount: amountAbs,
    gstClaimable: false,
    zeroGst: false,
    label,
    source: 'anz',
  };
  const key = normalizeBankTransactionPatternKey(label);
  const rule = rulesByPatternKey.get(key);
  if (!rule) {
    return { line: base, appliedRule: false };
  }
  return {
    line: applyCategorizationRuleToLine(base, rule),
    appliedRule: true,
  };
}
